module.exports = __webpack_public_path__ + "img/undo.acefd0cf.svg";